import styled from "styled-components";
import { useEffect, useState } from "react";
import piscina from '../images/piscina2.jpg';
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import Loading from "../components/Loading";

const Pool = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 668px)' });
  const {t} = useTranslation();
  const [active, setActive] = useState(0);
  const [left, setLeft] = useState('');
  const [width, setWidth] = useState('');

  const [loading, setLoading] = useState(true); // Stato per il caricamento delle immagini

  useEffect(() => {
    const loadImage = () => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = piscina; // Sostituisci con l'URL dell'immagine specifica
        img.onload = () => resolve();
        img.onerror = () => resolve(); // Risolve anche in caso di errore
      });
    };
  
    loadImage().then(() => setLoading(false));
  }, []); // Nessuna dipendenza se l'immagine è fissa
  

  
  const arr = [
    {
      id: 1,
      title: "piscina",
      content: "contenuto1"
    },
    {
      id: 2,
      title: "Pool Card",
      content: "contenuto2"
    },
    {
      id: 3,
      title: "regole",
      content: "contenuto3"
    },

  ]

  const change = (event, item) => {
    setActive(item)
    setLeft(event.target.offsetLeft);  
    setWidth(event.target.offsetWidth);
  }
  
  // Secondo useEffect: impostazione iniziale di left e width quando loading è false
  useEffect(() => {
    if (!loading) { // Esegui solo quando il caricamento è completato
      const firstBtn = document.querySelector(".tab_btn.active");
      if (firstBtn) {
        setLeft(firstBtn.offsetLeft);
        setWidth(firstBtn.offsetWidth);
      }
    }
  }, [loading]); // Dipende da loading

  if (loading) {
    return <Loading />;
  }

  return (
    <Wrapper className="container" style={!isMobile ? {paddingBottom: '50px'} : {}}>
      <div className="row">
        <div className="col-12 col-md-6 imgContainer" style={!isMobile ? {padding: '15px'} : {paddingBottom: '20px'}}>
          <img src={piscina} alt="" />
        </div>
        <div className="col-12 col-md-6" style={!isMobile ? {padding: '15px'} : {paddingBottom: '20px'}}>
            <div className="tab_box">
              {
                arr.map((elm, item) => {
                  return <button onClick={(event)=> change(event, item)} key={item} className={active === item ? 'tab_btn active' : 'tab_btn'}>{t(elm.title)}</button>
                })
              }
                <div className="line" style={{width: `${width}px`, left: `${left}px`}}></div>
            </div>
            <div className="content_box">
              {
                arr.map((elm, item) => {
                  const translateContent = t(elm.content);
                  const sentences = translateContent.split('.').filter(sentence => sentence.trim() !== '');

                  return <div key={item} className={active === item ? 'content active' : 'content'}>
                      <h2>{t(elm.title)}</h2>
                      {sentences.map((sentence, index) => (
                        <p className="piTag" key={index}>{sentence.trim()}.</p>
                      ))}
                  </div>
                })
              }
            </div>     
        </div>
      </div>
    </Wrapper>
  )
}

export default Pool;

const Wrapper = styled.div`

  .piTag {
    /* border: 1px solid black; */
    margin: 15px 0px;
  }
  .imgContainer img {
    display: block;
    border-radius: 10px;
    object-fit: cover;
    object-position: center;
    width: 100%;
  }
  .tab_box {
      width: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      border-bottom: 2px solid var(--gray);
      font-size: 18px;
      font-weight: 600;
      position: relative;
  }
  .tab_box .tab_btn {
      font-size: 18px;
      font-weight: 600;
      color: #919191;
      background: none;
      border: none;
      padding: 10px;
      cursor: pointer;
  }
  .tab_box .tab_btn.active {
      color: var(--logo);
  }
  .content_box {
      padding: 20px;
  }
  .content_box .content {
      display: none;
      animation: moving .5s ease;
  }
  @keyframes moving {
      from {transform: translateX(50px); opacity: 0;}
      to {transform: translateX(0px); opacity: 1;}
  }
  .content_box .content.active {
      display: block;
  }
  .content_box .content h2 {
      margin-bottom: 10px;
  }
  .line {
      position: absolute;
      /* width: calc(100% / 3); */
      /* left: 0px; */
      bottom: -3px;
      height: 5px;
      background-color: var(--logo);
      border-radius: 10px;
      transition: all .3s ease-in-out;
  }
`
